import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinchakanmidc() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Chakan MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Chakan MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited provides dependable and professional Corporate Cab Services in Chakan MIDC, catering to manufacturing units, automotive plants, warehouses, and corporate offices in this major industrial hub. Our fleet includes sedans, SUVs, and staff-transport vehicles suitable for employee shifts, management travel, client visits, and executive mobility. With expert chauffeurs, punctual operations, and flexible rental plans, we ensure smooth, safe, and efficient transportation every day. Whether your company needs daily pick-and-drop, shift-wise employee transport, dedicated corporate cars, or outstation business travel, Pune Corporate Cars India Private Limited delivers reliable and high-quality mobility solutions tailored to Chakan MIDC’s industrial requirements.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Chakan MIDC Staff Cab",
    "description": "Chakan MIDC Staff Cab offers reliable, safe, and perfectly coordinated transportation for employees working in Chakan MIDC. Our service includes AC sedans, SUVs, and shuttle vans with verified drivers and real-time tracking. Designed to support daily shift operations, Chakan MIDC Staff Cab ensures punctual, smooth, and stress-free commuting for industrial and corporate employees."
  },
  {
    "name": "Chakan Industrial Transport",
    "description": "Chakan Industrial Transport delivers systematic and efficient mobility solutions for companies operating in the Chakan industrial belt. From factory workers to management teams, our AC-equipped vehicles handle daily commute and field visits. With optimized routing, strict safety standards, and dependable chauffeurs, Chakan Industrial Transport is ideal for manufacturing and logistics organizations."
  },
  {
    "name": "Worker Pickup Drop Chakan",
    "description": "Worker Pickup Drop Chakan provides dedicated transportation for factory workers across all shifts. Early morning, mid-shift, and late-night routes are handled with complete safety protocols. Our vehicles are regularly maintained, comfortable, and monitored for route optimization. Worker Pickup Drop Chakan ensures workforce efficiency through safe and timely commuting."
  },
  {
    "name": "Corporate Shuttle Chakan",
    "description": "Corporate Shuttle Chakan offers high-capacity employee movement using AC minibuses, vans, and tempo travellers. Ideal for large factories, industrial units, and corporate parks, our shuttle service manages fixed routes, shift operations, and large team mobility. Corporate Shuttle Chakan ensures economical, organized, and uninterrupted transportation."
  },
  {
    "name": "Company Cab Provider Chakan",
    "description": "Company Cab Provider Chakan supplies professional cab services for businesses in Chakan MIDC. From executive movement to staff commute and client visits, our well-maintained cars and trained chauffeurs ensure dependable service. Companies can choose daily, weekly, or monthly plans. Company Cab Provider Chakan supports seamless corporate mobility across all requirements."
  },
  {
    "name": "Factory Staff Transport Cab",
    "description": "Factory Staff Transport Cab provides structured cab services for industrial employees working in manufacturing plants and production units. With GPS tracking, disciplined drivers, and AC vehicles, we ensure fast and safe transport across shifts. Factory Staff Transport Cab enhances employee convenience and supports smooth factory operations."
  },
  {
    "name": "Best Corporate Cabs Chakan",
    "description": "Best Corporate Cabs Chakan offers premium and well-managed cab services for companies requiring punctual travel, clean vehicles, and trained chauffeurs. Ideal for office commute, client visits, and management mobility, our fleet includes sedans and SUVs. Best Corporate Cabs Chakan ensures a smooth, reliable, and high-quality corporate travel experience."
  },
  {
    "name": "Monthly Corporate Cab Chakan",
    "description": "Monthly Corporate Cab Chakan provides long-term cab rentals with dedicated vehicles and professional chauffeurs. Perfect for executives, field staff, and daily office commute within Chakan MIDC and nearby areas. Predictable billing, vehicle availability, and priority service make Monthly Corporate Cab Chakan a dependable monthly travel solution."
  },
  {
    "name": "Business Taxi Chakan MIDC",
    "description": "Business Taxi Chakan MIDC delivers professional travel services for meetings, executive mobility, factory visits, and client transportation. Vehicles feature AC, clean interiors, and trained drivers who understand industrial routes. Business Taxi Chakan MIDC ensures timely and productive business travel for all corporate needs."
  },
  {
    "name": "Employee Commute Chakan",
    "description": "Employee Commute Chakan provides organized and safe daily transportation with fixed schedules, optimized routes, and professional chauffeurs. Our AC vehicles support shift-based operations and night commute safety. Employee Commute Chakan is ideal for manufacturing plants, warehouses, and corporate offices in Chakan MIDC."
  },
  {
    "name": "Corporate Fleet Chakan",
    "description": "Corporate Fleet Chakan offers complete fleet management for companies requiring multiple vehicles for daily operations. Sedans, SUVs, vans, and tempo travellers are assigned with driver management, maintenance, vehicle replacement, and tracking included. Corporate Fleet Chakan ensures smooth, efficient, and centralized mobility for large organizations."
  },
  {
    "name": "Outstation Cab Chakan",
    "description": "Outstation Cab Chakan provides comfortable and reliable intercity travel for corporate meetings, industrial visits, and long-distance business trips. Our sedans and SUVs are maintained for extended travel, offering comfort and safety throughout the journey. Outstation Cab Chakan ensures timely and professional outstation mobility."
  },
  {
    "name": "Chakan Sedan Cab",
    "description": "Chakan Sedan Cab offers premium sedans like Dzire, Etios, Honda City, and Verna for executive and staff travel. Perfect for meetings, airport runs, and inter-office visits, our sedans provide comfort, AC interiors, and smooth rides. Chakan Sedan Cab guarantees a clean, comfortable, and punctual travel experience."
  },
  {
    "name": "Chakan SUV Cab",
    "description": "Chakan SUV Cab delivers high-comfort SUVs such as Ertiga, Innova, and Crysta for corporate and industrial clients. These vehicles are ideal for group travel, long routes, and executive mobility. With extra space and premium comfort, Chakan SUV Cab ensures superior travel quality for all business needs."
  },
  {
    "name": "Industrial Cab Services Chakan",
    "description": "Industrial Cab Services Chakan provides tailored cab solutions for factories, warehouses, logistics units, and industrial plants. Our service focuses on safety, punctuality, and efficiency, with clean AC vehicles and experienced drivers. Industrial Cab Services Chakan supports smooth daily operations and secure employee transportation."
  }
],
"tableData": [
  ["Chakan MIDC Staff Cab", "Chakan Industrial Transport"],
  ["Worker Pickup Drop Chakan", "Corporate Shuttle Chakan"],
  ["Company Cab Provider Chakan", "Factory Staff Transport Cab"],
  ["Best Corporate Cabs Chakan", "Monthly Corporate Cab Chakan"],
  ["Business Taxi Chakan MIDC", "Employee Commute Chakan"],
  ["Corporate Fleet Chakan", "Outstation Cab Chakan"],
  ["Chakan Sedan Cab", "Chakan SUV Cab"],
  ["Industrial Cab Services Chakan", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Chakan MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable and efficient corporate cab services in Chakan MIDC, ensuring smooth and timely transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Ideal for Industrial & Manufacturing Companies",
    "WhyChoosedescription": "Our services are perfectly suited for companies in Chakan MIDC, providing dependable travel solutions for shift workers and corporate staff."
  },
  {
    "WhyChooseheading": "Clean, Safe & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced and sanitized to ensure a safe, hygienic, and comfortable commuting experience."
  },
  {
    "WhyChooseheading": "Transparent & Affordable Pricing",
    "WhyChoosedescription": "We offer clear and competitive pricing with no hidden fees, ideal for daily, monthly, and long-term corporate travel contracts."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Plans",
    "WhyChoosedescription": "Choose from customized pickup and drop schedules designed to match employee shifts, factory timings, and corporate travel needs."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe driving, punctuality, and a smooth travel experience for all corporate passengers."
  },
  {
    "WhyChooseheading": "24/7 Corporate Assistance",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with schedule adjustments, urgent travel requirements, and bookings."
  },
  {
    "WhyChooseheading": "Quick & Seamless Booking",
    "WhyChoosedescription": "Book your corporate cab for Chakan MIDC easily via our online portal or phone, with fast confirmations and reliable service."
  }
]






















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Chakan MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Chakan MIDC for employee transportation, business travel, and industrial visits.',
  },
  {
    question: 'How can I book a corporate cab in Chakan MIDC with Pune Corporate Cars India Private Limited?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Chakan MIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and premium cars suitable for corporate and manufacturing sector travel needs.',
  },
  {
    question: 'Are the drivers trained for corporate and industrial routes in Chakan MIDC?',
    answer: 'Yes, our drivers are experienced, professional, and well-versed with Chakan MIDC industrial routes and shift timings.',
  },
  {
    question: 'Do you offer daily, weekly, or monthly corporate cab packages in Chakan MIDC?',
    answer: 'Absolutely. We provide flexible daily, weekly, and monthly corporate cab plans tailored for companies operating in Chakan MIDC.',
  },
  {
    question: 'Is the corporate cab service available 24×7 in Chakan MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited operates round-the-clock to support all corporate travel and shift requirements in Chakan MIDC.',
  },
  {
    question: 'What safety and hygiene protocols are followed for corporate cabs in Chakan MIDC?',
    answer: 'All vehicles are regularly sanitized, and our drivers follow strict hygiene and safety guidelines for every ride.',
  },
  {
    question: 'What payment options are accepted for corporate cab services in Chakan MIDC?',
    answer: 'We accept UPI, credit/debit cards, net banking, digital wallets, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the corporate cab service?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you anytime during your service period.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Salunkhe',
    feedback: 'Very dependable corporate cab service in Chakan MIDC. The drivers are punctual and understand industrial shift timings well.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Jagtap',
    feedback: 'Our factory staff uses Pune Corporate Cars India Private Limited regularly in Chakan MIDC. Excellent service and smooth coordination every time.',
    rating: 5,
  },
];












































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Chakan MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-chakan.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Chakan MIDC, Pune, offering staff transport, office and factory pickup and drop, industrial area shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies in Chakan.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4400", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-chakan-midc"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Chakan MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Chakan MIDC, Pune, offering staff transport, office and factory pickup and drop, industrial area shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies in Chakan."
  />

  <meta
    name="keywords"
    content="Chakan MIDC Staff Cab, Chakan Industrial Transport, Worker Pickup Drop Chakan, Corporate Shuttle Chakan, Company Cab Provider Chakan, Factory Staff Transport Cab, Best Corporate Cabs Chakan, Monthly Corporate Cab Chakan, Business Taxi Chakan MIDC, Employee Commute Chakan, Corporate Fleet Chakan, Outstation Cab Chakan, Chakan Sedan Cab, Chakan SUV Cab, Industrial Cab Services Chakan"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinchakanmidc;